<template>
	<div class="select-lists">
		<div class="select-lists.list" v-if="lists.length > 0">
			<div class="select-lists.card" v-for="(item,index) in lists" :key="index" @click="goDetail(item)" data-aos="zoom-in-up">
				<span><img :src="item.icon" alt=""></span>
				<div class="select-lists.card.line"></div>
				<h2>{{item.title}}</h2>
				<p v-if="item.priceDesc">价格
					<mark>{{item.priceDesc}}</mark>
					元</p>
				<p v-else>{{item.desc}}</p>
				<div class="select-lists.card.btn" :class="{'--active-btn':item.priceDesc}">
					<button v-show="!item.priceDesc" @click="consulationList">询价</button>
					<button @click="consulationList">联系卖家</button>
				</div>
				<div class="select-lists.card.type" v-show="item.type == '版权'">
					<img src="../assets/tejia/banquan-tra.png" alt="">
					<img src="../assets/tejia/banquan.png" alt="">
					<p>
						<span>版</span>
						<span>权</span>
					</p>
				</div>
				<div class="select-lists.card.type" v-show="item.type == '商标'">
					<img src="../assets/tejia/shangbiao-tra.png" alt="">
					<img src="../assets/tejia/shangbiao.png" alt="">
					<p>
						<span>商</span>
						<span>标</span>
					</p>
				</div>
				<div class="select-lists.card.type" v-show="item.type == '专利'">
					<img src="../assets/tejia/zhuanli-tra.png" alt="">
					<img src="../assets/tejia/zhuanli.png" alt="">
					<p>
						<span>专</span>
						<span>利</span>
					</p>
				</div>
			</div>
		</div>
		<div class="select-lists.nodata" v-else>暂无数据</div>
		<div class="select-lists.page" v-show="pageParams.totalMCount > this.pagePer">
			<el-pagination background layout="prev, pager, next" :hide-on-single-page="true" @size-change="handleMChange"
			 @current-change="handleMCurrentChange" :current-page.sync="pageParams.pageMNo" :page-size="pageSize" :total="pageParams.totalMCount">
			</el-pagination>
		</div>
		<consultation-modal :consultationShow="consultationShow" @closeConsultationEvent="closeConsultationEvent"></consultation-modal>
	</div>
</template>

<script>
	import ConsultationModal from '../components/consultation-modal.vue'
	export default {
		props: {
			lists:{
				string: Array,
				default: (()=>{
					return []
				})
			},
			pageParams:{
				string: Object,
				default: (()=>{
					return {}
				})
			},
			pageSize: {
				string: Number,
				default: 16
			}
		},
		components:{
			ConsultationModal
		},
		data(){
			return{
				consultationShow:false,
				
			}
		},
		methods:{
			goDetail(row){
				let path = (this.$route.path=='/'?'Patent':this.$route.path) + '/' +row.id;
				sessionStorage.setItem('detail',JSON.stringify(row))
				if(row.type){
					switch(row.type){
					  case '版权':
					  path =`/Copyright/${row.id}`;
					  break;
					  case '商标':
					  path = `/Trademark/${row.id}`;
					  break;
					  case '专利':
					  path = `/Patent/${row.id}`;
					  break;
					  default:
					  path = this.$router.push(this.$route.path + '/' +row.id)
					}
				}
				//this.$router.push(path)
				
				let routeUrl = this.$router.resolve({
					path: path,
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
			},
			consulationList(event){
				event.stopPropagation();
				this.consultationShow = true
			},
			getPageMData(){
				this.$emit('updateLists',this.pageParams.pageMNo)
			},
			handleMChange(val) {
				this.$nextTick(() => {
					this.getPageMData()
				})
			},
			handleMCurrentChange(val) {
				this.getPageMData()
			},
			closeConsultationEvent(val){
				this.consultationShow = val
			}
		}
	}
</script>

<style lang="scss" scoped>
	@include component(select-lists) {
		width: 100%;
		color: #333333;

		@include part(list) {
			width: 100%;
			//box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			margin: 10px 0;
			display: flex;
			justify-content: flex-start;
			flex-wrap: wrap;
		}

		@include part(card) {
			width: 226px;
			height: 270px;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			//overflow: hidden;
			border: none;
			box-sizing: border-box;
			padding: 0 33px;
			margin-right: 12px;
			border: 1px solid transparent;
			cursor: pointer;
			position: relative;

			&:nth-child(n+5) {
				margin-top: 10px;
			}

			&:nth-child(4n) {
				margin-right: 0;

			}

			>span {
				display: inline-block;
				transition: all 0.35s linear;
				width: 100%;
				height: 108px;
				//margin-top: 52px;
				transform: scale(1) translateY(20px);
				img{
					display: block;
					width: 100%;
					height: 100%;
					object-fit: contain;
					object-position: center;
				}
			}

			@include part(line) {
				width: 100%;
				height: 1px;
				background: #F2F2F2;
				margin-top: 39px;
				transition: all 0.35s linear;
				transform: scale(1) translateY(27px);
			}

			>h2 {
				margin: 0;
				font-size: 18px;
				transition: all 0.35s linear;
				margin-top: 21px;
				transform: scale(1) translateY(18px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
			}

			>p {
				width: 100%;
				color: #999999;
				font-size: 16px;
				transition: all 0.35s linear;
				margin-top: 10px;
				transform: scale(1) translateY(10px);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				

				mark {
					color: #F47227;
					font-weight: bold;
					background: none;
				}

			}

			@include part(btn) {
				display: flex;
				justify-content: center;
				transition: all 0.35s linear;
				margin-top: 10px;
				transform: scale(0);

				button {
					width: 79px;
					height: 32px;
					border-radius: 2px;
					font-size: 14px;
					border: none;
					outline: none;
					color: #fff;
					cursor: pointer;

					&:nth-child(1) {
						background: rgba(43, 162, 70, 1);
						margin-right: 5px;
					}

					&:nth-child(2) {
						background: #F47227;
					}
				}

				@include option(active-btn) {
					button {
						width: 100%;
					}
				}
			}

			&:hover {
				border-color: #F47227;

				>span {
					transform: scale(0.9) translateY(0);
				}

				@include part(line) {
					transform: scale(0.9) translateY(0);
				}

				>h2 {
					transform: scale(0.9) translateY(-9px);
				}

				>p {
					transform: scale(0.9) translateY(-18px);
				}

				@include part(btn) {
					transform: scale(1) translateY(-18px)
				}
			}

			@include part(type) {
				position: absolute;
				top: -5px;
				right:20px;
				width: 31px;
				height: 50px;
				display: flex;
				justify-content: space-between;

				img {
					display: block;

					&:nth-child(1) {
						position: absolute;
						top: 0;
						left: 0;
					}

					&:nth-child(2) {
						position: absolute;
						right: 0;
					}
				}

				p {
					position: absolute;
					top: 0;
					right: 0;
					width: 26px;
					height: 100%;
					display: flex;
					flex-direction: column;
					font-size: 14px;
					color: #FFFFFF;
				}


			}
		}

		@include part(page) {
			width: 100%;
			height: 80px;
			background: #fff;
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		@include part(nodata){
			width: 100%;
			height: 500px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

	}
</style>
